import { MiniGameDataObject } from "./MiniGameDataObject.js";

export function WordRushGameObject(){
    return MiniGameDataObject("WordRush")
}